import { Component, OnInit, OnDestroy, EventEmitter, Output, inject } from '@angular/core';
import { Product, MapperSaleProduct, buildAddSource } from '../../../../dto';
import { Router } from '@angular/router';
import { buildQuickCartRequest, canBuildCartRequest } from '../../../../common/cart-request.util';
import { CartService, ProductService, GaService, UtmStorageService } from '../../../../services';
import { BaseComponent } from '../../../../core';
import * as CartStore from '../../../../store/cart';
import * as IndicatorStore from '../../../../store/indicator';
import * as SelectProductStore from '../../../../store/select-product';
import { takeWhile } from 'rxjs/operators';
@Component({
  selector: 'app-select-product',
  templateUrl: './select-product.component.html',
  styleUrls: ['./select-product.component.scss'],
  standalone: false,
})
export class SelectProductComponent extends BaseComponent implements OnInit, OnDestroy {
  selectedProduct: Product;
  selectedProductType: number;
  isShowAddToCartModal: boolean;
  itemListName?: string;
  itemIndex = 0;
  cartContextUrl?: string;

  @Output()
  isOptionSelect = new EventEmitter<any>();

  private cartService = inject(CartService);
  private productService = inject(ProductService);
  private gaService = inject(GaService);
  private utmStorage = inject(UtmStorageService);
  private router = inject(Router);

  ngOnInit() {
    this.productService.resetSubject$.pipe(takeWhile(() => this.isAlive)).subscribe(async (products) => {
      this.selectedProduct?.mapperSaleProducts.forEach((mapperSaleProduct) => {
        if (products === undefined) {
          mapperSaleProduct.optionCheck = false;
        } else {
          for (let i = 0; i < products.length; i++) {
            if (products[i].id === mapperSaleProduct.id) {
              mapperSaleProduct.optionCheck = true;
              return;
            } else {
              mapperSaleProduct.optionCheck = false;
            }
          }
        }
      });
    });
    this.store
      .select(SelectProductStore.SELECT_PRODUCT_STORE_NAME)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((selectProductPayload) => {
        if (selectProductPayload && selectProductPayload.selectType === 0) {
          this.itemListName = selectProductPayload.itemListName;
          this.itemIndex = selectProductPayload.itemIndex ?? 0;
          this.cartContextUrl = selectProductPayload.cartContextUrl;
          this.open(selectProductPayload.product);
          this.store.dispatch(new SelectProductStore.RemoveProduct());
        } else if (selectProductPayload?.selectType === 1) {
          this.selectedProduct = this.productService.mergeInvalidCountry(selectProductPayload.product);
          this.store.dispatch(new SelectProductStore.RemoveProduct());
          this.isShowAddToCartModal = true;
        }
      });
  }

  addToCart(selectedSaleProduct: MapperSaleProduct) {
    const requestUrl = this.cartContextUrl ?? this.router.url;
    if (!canBuildCartRequest(selectedSaleProduct, requestUrl)) {
      return;
    }
    const saleProduct = buildQuickCartRequest(selectedSaleProduct, {
      currentUrl: this.router.url,
      slotUrl: this.cartContextUrl,
      addSource: buildAddSource(this.itemListName, this.utmStorage.get()),
    });
    this.cartService.addToCart(saleProduct).subscribe(
      (cart) => {
        const dialog = this._openDialog({
          message: cart.isUpdated ? this.i18n.t('CART.ADDED_MIN') : 'The product is already in your cart.',
          close: () => {
            dialog.close();
          },
        });
        this.store.dispatch(new CartStore.AddCart(cart));
        this.gaService.logAddToCart([cart], this.itemListName, {
          isChecked: !!selectedSaleProduct.optionCheck,
          sourceMapperSaleProducts: [selectedSaleProduct],
        });
      },
      (error) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('addToCart'));
        this.errors = error;
        const errorDialog = this._openDialog({
          message: this.errors.message,
          close: () => {
            errorDialog.close();
          },
        });
      }
    );
  }

  addToSelect(product) {
    if (
      !product.optionCheck &&
      (product.productStatus === this.PRODUCT_STATUS.OUT_OF_STOCK ||
        !canBuildCartRequest(product, this.cartContextUrl ?? this.router.url))
    ) {
      return;
    }
    if (this.selectedProduct?.mapperSaleProducts.length > 1) {
      const isChecked = this.productService.addToSelect(product, this.itemListName, this.cartContextUrl);
      this.gaService.logSelectItemCheckbox(this.selectedProduct, this.itemListName, {
        isChecked,
        index: this.itemIndex,
      });
    }
  }

  public open(selectedProduct: Product) {
    if (selectedProduct.mapperSaleProducts.length === 1) {
      this.addToCart(selectedProduct.mapperSaleProducts[0]);
    } else {
      this.selectedProduct = this.productService.mergeInvalidCountry(selectedProduct);
      this.isShowAddToCartModal = true;
    }
  }

  onCloseAddToCartModal() {
    this.isShowAddToCartModal = false;
  }
}
